import React from "react";
import SubHeadingBanner from "../components/organisms/SubHeadingBanner";
import useScrollToTop from "../hooks/useScrollToTop";
import HeadingText from "../components/atoms/HeadingText";
import ContentText from "../components/atoms/ContentText";
import useTranslate from "../hooks/useTranslate";
import workwithMN from "../assets/images/workwithmn.avif";
import workshop1 from "../assets/images/workshop 1.png";
import { useNavigate } from "react-router-dom";

function CorporateNutritionPage() {
  useScrollToTop();
  const navigate = useNavigate();

  const pageTitle = useTranslate("nav.corporateNutrition");
  const heading2 = useTranslate("corporateNutritionPage.section.heading2");
  const heading3 = useTranslate("corporateNutritionPage.section.heading3");
  const contentText1 = useTranslate(
    "corporateNutritionPage.section.contentText1",
  );
  const contentText2 = useTranslate(
    "corporateNutritionPage.section.contentText2",
  );
  const servicesHeading = useTranslate(
    "corporateNutritionPage.section.servicesHeading",
  );
  const oneToOneHeading = useTranslate(
    "corporateNutritionPage.section.oneToOneHeading",
  );
  const oneToOneSubtitle = useTranslate(
    "corporateNutritionPage.section.oneToOneSubtitle",
  );
  const oneToOneContent = useTranslate(
    "corporateNutritionPage.section.oneToOneContent",
  );
  const oneToOneList = useTranslate(
    "corporateNutritionPage.section.oneToOneList",
  );
  const groupWorkshopsHeading = useTranslate(
    "corporateNutritionPage.section.groupWorkshopsHeading",
  );
  const groupWorkshopsSubtitle = useTranslate(
    "corporateNutritionPage.section.groupWorkshopsSubtitle",
  );
  const groupWorkshopsContent = useTranslate(
    "corporateNutritionPage.section.groupWorkshopsContent",
  );
  const tailoredMealPlansHeading = useTranslate(
    "corporateNutritionPage.section.tailoredMealPlansHeading",
  );
  const tailoredMealPlansSubtitle = useTranslate(
    "corporateNutritionPage.section.tailoredMealPlansSubtitle",
  );
  const tailoredMealPlansContent = useTranslate(
    "corporateNutritionPage.section.tailoredMealPlansContent",
  );
  const tailoredMealPlansList = useTranslate(
    "corporateNutritionPage.section.tailoredMealPlansList",
  );
  const dailyMealBoxesHeading = useTranslate(
    "corporateNutritionPage.section.dailyMealBoxesHeading",
  );
  const dailyMealBoxesSubtitle = useTranslate(
    "corporateNutritionPage.section.dailyMealBoxesSubtitle",
  );
  const dailyMealBoxesContent = useTranslate(
    "corporateNutritionPage.section.dailyMealBoxesContent",
  );
  const dailyMealBoxesList = useTranslate(
    "corporateNutritionPage.section.dailyMealBoxesList",
  );
  const whyHeading = useTranslate("corporateNutritionPage.section.whyHeading");
  const whyPoints = useTranslate("corporateNutritionPage.section.whyPoints");
  const benefitsHeading = useTranslate(
    "corporateNutritionPage.section.benefitsHeading",
  );
  const benefits = useTranslate("corporateNutritionPage.section.benefits");
  const gettingStartedHeading = useTranslate(
    "corporateNutritionPage.section.gettingStartedHeading",
  );
  const gettingStarted = useTranslate(
    "corporateNutritionPage.section.gettingStarted",
  );
  const readyToTransform = useTranslate(
    "corporateNutritionPage.section.readyToTransform",
  );

  return (
    <div>
      <SubHeadingBanner
        imageSrc={workwithMN}
        head1="Home - Corporate Nutrition"
        head2={pageTitle}
      />
      <section className="bg-white py-16">
        <div className="max-w-6xl mx-auto px-4">
          {/* Hero Section */}
          <div className="mb-16">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div className="space-y-6">
                <HeadingText variant="h2">{heading2}</HeadingText>
                <HeadingText variant="h3" classes="!text-primary !mb-8">
                  {heading3}
                </HeadingText>
                <div className="space-y-6">
                  <ContentText>{contentText1}</ContentText>
                  <ContentText>{contentText2}</ContentText>
                </div>
              </div>
              <div className="relative">
                <div className="relative overflow-hidden rounded-3xl">
                  <img
                    src={workshop1}
                    alt="Corporate Nutrition Workshop"
                    className="w-full h-80 lg:h-96 object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
                </div>
                <div className="absolute -bottom-6 -right-6 w-24 h-24 bg-primary/10 rounded-full blur-xl"></div>
                <div className="absolute -top-6 -left-6 w-16 h-16 bg-primary/20 rounded-full blur-lg"></div>
              </div>
            </div>
          </div>

          {/* Services Section */}
          <div className="mb-24">
            <HeadingText variant="h2" classes="mb-12">
              {servicesHeading}
            </HeadingText>
            <div className="space-y-20">
              {/* Service 1: One-to-One */}
              <div className="pb-16 border-b border-gray-200">
                <HeadingText variant="h3">{oneToOneHeading}</HeadingText>
                <HeadingText variant="h4" classes="!text-gray-600 !mb-8">
                  {oneToOneSubtitle}
                </HeadingText>
                <div className="space-y-8">
                  <ContentText>{oneToOneContent}</ContentText>

                  {/* What's Included */}
                  {Array.isArray(oneToOneList) && (
                    <div className="bg-gradient-to-br from-orange-50/30 to-white border-l-4 border-orange-400 rounded-r-lg p-8 shadow-sm">
                      <HeadingText
                        variant="h4"
                        classes="!text-lg !mb-6 !text-orange-800"
                      >
                        What's Included:
                      </HeadingText>
                      <ul className="list-disc list-inside space-y-3 pl-2">
                        {oneToOneList.map((item, index) => (
                          <li
                            key={index}
                            className="text-gray-700 text-base leading-relaxed"
                          >
                            {item}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}

                  {/* Organizational Benefits */}
                  <div className="bg-white border-l-4 border-primary rounded-r-lg p-8 shadow-sm">
                    <HeadingText
                      variant="h4"
                      classes="!text-lg !mb-4 !text-primary"
                    >
                      Organizational Benefits:
                    </HeadingText>
                    <p className="text-gray-700 leading-relaxed text-base">
                      Employees receive individualized attention that respects
                      privacy while demonstrating your commitment to their
                      wellbeing. This targeted approach yields higher engagement
                      rates and measurable health improvements compared to
                      generalized wellness initiatives.
                    </p>
                  </div>
                </div>
              </div>

              {/* Service 2: Group Workshops */}
              <div className="pb-16 border-b border-gray-200">
                <HeadingText variant="h3">{groupWorkshopsHeading}</HeadingText>
                <HeadingText variant="h4" classes="!text-gray-600 !mb-8">
                  {groupWorkshopsSubtitle}
                </HeadingText>
                <div className="space-y-8">
                  <ContentText>{groupWorkshopsContent}</ContentText>
                </div>
              </div>

              {/* Service 3: Tailored Meal Plans */}
              <div className="pb-16 border-b border-gray-200">
                <HeadingText variant="h3">
                  {tailoredMealPlansHeading}
                </HeadingText>
                <HeadingText variant="h4" classes="!text-gray-600 !mb-8">
                  {tailoredMealPlansSubtitle}
                </HeadingText>
                <div className="space-y-8">
                  <ContentText>{tailoredMealPlansContent}</ContentText>

                  {/* Service Components */}
                  {Array.isArray(tailoredMealPlansList) && (
                    <div className="bg-gradient-to-br from-green-50/20 to-white border-l-4 border-green-500 rounded-r-lg p-8 shadow-sm">
                      <HeadingText
                        variant="h4"
                        classes="!text-lg !mb-6 !text-green-700"
                      >
                        Service Components:
                      </HeadingText>
                      <ul className="list-disc list-inside space-y-3 pl-2">
                        {tailoredMealPlansList.map((item, index) => (
                          <li
                            key={index}
                            className="text-gray-700 text-base leading-relaxed"
                          >
                            {item}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}

                  {/* Specialized Plans */}
                  <div className="bg-gradient-to-br from-amber-50/20 to-white border-l-4 border-amber-500 rounded-r-lg p-8 shadow-sm">
                    <HeadingText
                      variant="h4"
                      classes="!text-lg !mb-6 !text-amber-700"
                    >
                      Specialized Plans Available:
                    </HeadingText>
                    <div className="grid md:grid-cols-2 gap-4">
                      <div className="space-y-3">
                        <div className="flex gap-3">
                          <span className="text-amber-600 font-bold">•</span>
                          <p className="text-gray-700 text-base">
                            Weight management (controlled energy deficit or
                            surplus)
                          </p>
                        </div>
                        <div className="flex gap-3">
                          <span className="text-amber-600 font-bold">•</span>
                          <p className="text-gray-700 text-base">
                            Metabolic health optimization (diabetes
                            prevention/management, stress control, fatigue)
                          </p>
                        </div>
                        <div className="flex gap-3">
                          <span className="text-amber-600 font-bold">•</span>
                          <p className="text-gray-700 text-base">
                            Cardiovascular protection (DASH-style or
                            Mediterranean dietary patterns)
                          </p>
                        </div>
                      </div>
                      <div className="space-y-3">
                        <div className="flex gap-3">
                          <span className="text-amber-600 font-bold">•</span>
                          <p className="text-gray-700 text-base">
                            Digestive health and elimination diets (low-FODMAP,
                            anti-inflammatory protocols)
                          </p>
                        </div>
                        <div className="flex gap-3">
                          <span className="text-amber-600 font-bold">•</span>
                          <p className="text-gray-700 text-base">
                            Plant-based and vegetarian optimization
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Evidence-Based Frameworks */}
                  <div className="bg-gradient-to-br from-teal-50/20 to-white border-l-4 border-teal-500 rounded-r-lg p-8 shadow-sm">
                    <HeadingText
                      variant="h4"
                      classes="!text-lg !mb-4 !text-teal-700"
                    >
                      Evidence-Based Frameworks:
                    </HeadingText>
                    <p className="text-gray-700 leading-relaxed text-base">
                      Our meal plans incorporate principles from established
                      dietary patterns with robust clinical evidence, including
                      Mediterranean diet frameworks, DASH (Dietary Approaches to
                      Stop Hypertension), low-glycemic eating patterns, and
                      anti-inflammatory protocols—all adapted to individual
                      preferences and cultural contexts.
                    </p>
                  </div>
                </div>
              </div>

              {/* Service 4: Daily Meal Boxes */}
              <div className="pb-16 border-b border-gray-200">
                <HeadingText variant="h3">{dailyMealBoxesHeading}</HeadingText>
                <HeadingText variant="h4" classes="!text-gray-600 !mb-8">
                  {dailyMealBoxesSubtitle}
                </HeadingText>
                <div className="space-y-8">
                  <ContentText>{dailyMealBoxesContent}</ContentText>

                  {/* Service Features */}
                  {Array.isArray(dailyMealBoxesList) && (
                    <div className="bg-gradient-to-br from-emerald-50/20 to-white border-l-4 border-emerald-500 rounded-r-lg p-8 shadow-sm">
                      <HeadingText
                        variant="h4"
                        classes="!text-lg !mb-6 !text-emerald-700"
                      >
                        Service Features:
                      </HeadingText>
                      <ul className="list-disc list-inside space-y-3 pl-2">
                        {dailyMealBoxesList.map((item, index) => (
                          <li
                            key={index}
                            className="text-gray-700 text-base leading-relaxed"
                          >
                            {item}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}

                  {/* Quality Assurance & Advantages - Equal Height Cards */}
                  <div className="grid md:grid-cols-2 gap-8">
                    <div className="bg-gradient-to-br from-amber-50/20 to-white border-l-4 border-amber-500 rounded-r-lg p-8 shadow-sm h-full">
                      <HeadingText
                        variant="h4"
                        classes="!text-lg !mb-4 !text-amber-700"
                      >
                        Quality Assurance:
                      </HeadingText>
                      <p className="text-gray-700 leading-relaxed text-base">
                        All meals are prepared in compliance with food safety
                        standards, with ingredient sourcing prioritizing
                        seasonal, local, and sustainably produced options where
                        possible. Nutritional adequacy is verified against
                        established dietary reference intakes.
                      </p>
                    </div>
                    <div className="bg-gradient-to-br from-purple-50/20 to-white border-l-4 border-purple-500 rounded-r-lg p-8 shadow-sm h-full">
                      <HeadingText
                        variant="h4"
                        classes="!text-lg !mb-4 !text-purple-700"
                      >
                        Organizational Advantages:
                      </HeadingText>
                      <p className="text-gray-700 leading-relaxed text-base">
                        By providing nutritionally complete meals on-site, your
                        organization removes barriers to healthy eating, reduces
                        time lost to lunch procurement, demonstrates tangible
                        investment in employee wellbeing, and creates
                        opportunities for team members to share
                        meals—strengthening workplace culture.
                      </p>
                    </div>
                  </div>

                  {/* Pricing */}
                  <div className="bg-gradient-to-br from-cyan-50/20 to-white border-l-4 border-cyan-500 rounded-r-lg p-8 shadow-sm">
                    <HeadingText
                      variant="h4"
                      classes="!text-lg !mb-4 !text-cyan-700"
                    >
                      Pricing:
                    </HeadingText>
                    <p className="text-gray-700 leading-relaxed text-base">
                      Volume-based pricing ensures affordability at scale, with
                      tiered options for different organizational sizes and
                      commitment levels. Custom packages are available for
                      specific departmental needs or executive teams.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Why Choose Us Section */}
          <div className="mb-24">
            <HeadingText variant="h2" classes="mb-12">
              {whyHeading}
            </HeadingText>
            <div className="grid md:grid-cols-2 gap-10">
              {whyPoints.map((item, index) => (
                <div
                  key={index}
                  className="bg-white rounded-3xl p-8 shadow-sm border border-gray-200 hover:shadow-lg transition-all duration-300"
                >
                  <div className="flex items-center gap-4 mb-6">
                    <div className="flex h-12 w-12 items-center justify-center rounded-full bg-primary text-white font-bold text-lg">
                      {index + 1}
                    </div>
                    <HeadingText
                      variant="h4"
                      classes="!text-lg !mb-0 !text-gray-900"
                    >
                      {item.title}
                    </HeadingText>
                  </div>
                  <p className="text-gray-700 leading-relaxed text-base">
                    {item.description}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Benefits Section */}
          <div className="mb-24">
            <div className="max-w-3xl">
              <HeadingText variant="h2" classes="mb-4">
                {benefitsHeading || "Benefits for Your Business"}
              </HeadingText>
              <p className="text-gray-600 text-lg mb-10">
                Discover the measurable impact of comprehensive corporate
                nutrition programs.
              </p>
            </div>
            {Array.isArray(benefits) && (
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                {benefits.map((benefit, index) => (
                  <div
                    key={index}
                    className="group rounded-3xl border border-gray-200 p-6 shadow-sm hover:shadow-md transition-all duration-300 h-full"
                  >
                    <div className="flex items-start gap-4">
                      <div className="flex h-12 w-12 items-center justify-center rounded-full text-primary font-bold text-xl leading-none">
                        ✓
                      </div>
                      <p className="text-gray-700 leading-relaxed text-base font-medium">
                        {benefit.includes(":") ? (
                          <>
                            <span className="font-bold">
                              {benefit.split(":")[0]}:
                            </span>
                            {benefit.split(":").slice(1).join(":")}
                          </>
                        ) : (
                          benefit
                        )}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Getting Started Section */}
          <div className="mb-24">
            <HeadingText variant="h2" classes="mb-12">
              {gettingStartedHeading}
            </HeadingText>
            {Array.isArray(gettingStarted) && (
              <div className="space-y-6">
                {gettingStarted.map((step, index) => (
                  <div
                    key={index}
                    className="flex gap-6 bg-white border border-gray-200 rounded-lg p-8 shadow-sm hover:shadow-md transition-shadow"
                  >
                    <div className="flex-shrink-0">
                      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-primary text-white font-bold text-xl">
                        {index + 1}
                      </div>
                    </div>
                    <div className="pt-2">
                      <p className="text-gray-700 leading-relaxed text-base">
                        {step.includes(":") ? (
                          <>
                            <span className="font-bold">
                              {step.split(":")[0]}:
                            </span>
                            {step.split(":").slice(1).join(":")}
                          </>
                        ) : (
                          step
                        )}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Investment Section */}
          <div className="mb-24">
            <div className="max-w-4xl mx-auto text-center">
              <p className="text-gray-800 text-xl md:text-2xl font-bold text-primary mb-6">
                Invest in Your Most Valuable Asset
              </p>
              <div className="w-24 h-1 bg-primary rounded-full mx-auto mb-10"></div>
              <p className="text-gray-700 leading-relaxed text-lg md:text-xl max-w-3xl mx-auto mb-6">
                Your employees are your organization's foundation. Their
                cognitive capacity, physical vitality, and sustained wellbeing
                directly influence every business outcome you measure.
              </p>
              <p className="text-gray-800 leading-relaxed text-lg md:text-xl font-semibold max-w-3xl mx-auto">
                Comprehensive nutrition support isn't a luxury—it's a strategic
                investment in organizational performance, resilience, and
                competitive advantage. We make evidence-based corporate
                nutrition accessible, affordable, and impactful for businesses
                of all sizes.
              </p>
            </div>
          </div>

          {/* CTA Section */}
          {readyToTransform && (
            <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-primary via-primary/95 to-primary/90 p-12 md:p-16 text-center text-white">
              {/* Background Pattern */}
              <div className="absolute inset-0 opacity-10">
                <div className="absolute top-10 left-10 w-20 h-20 border border-white/20 rounded-full"></div>
                <div className="absolute top-32 right-16 w-12 h-12 border border-white/20 rounded-full"></div>
                <div className="absolute bottom-20 left-20 w-16 h-16 border border-white/20 rounded-full"></div>
                <div className="absolute bottom-10 right-10 w-8 h-8 border border-white/20 rounded-full"></div>
              </div>
              <div className="relative z-10 max-w-3xl mx-auto">
                <HeadingText variant="h2" classes="!text-white !mb-8">
                  Ready to transform your workplace wellness approach?
                </HeadingText>
                <p className="text-white/95 text-xl leading-relaxed mb-12 max-w-2xl mx-auto">
                  Let's work together to create a healthier, more productive
                  workplace. Our nutrition experts are ready to develop a
                  customized corporate wellness strategy that aligns with your
                  organizational goals.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                  <button
                    onClick={() => navigate("/get-in-touch")}
                    className="px-12 py-5 bg-white text-primary font-semibold rounded-xl hover:bg-gray-50 transition-all duration-300 hover:scale-105 text-lg"
                  >
                    Contact Us
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}

export default CorporateNutritionPage;
